import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import useAPI from '../../../api';
import { Paper, Typography } from '@mui/material';
import { FullSizeCenteredFlexBox } from '../../../Components/FlexBox';
import SearchBox from '../../../Components/Inputs/SearchBox';
import Select from '../../../Components/Inputs/Select';
import mapFilters from '../../../Helpers/Filters/mapFilters';
import { useAtomValue } from 'jotai';
import { userDataAtom } from '../../../Atoms';

const FiltersPaper = function FiltersPaper({
  filters,
  setFilters,
  isOperator = false,
}) {
  const API = useAPI();
  const intl = useIntl();
  const userData = useAtomValue(userDataAtom);
  const [campaigns, setCampaigns] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);

  useEffect(() => {
    if (isOperator) {
      setOperatorsList([
        {
          value: 0,
          label: intl.messages.NO_SELECTION,
        },
        {
          label: `${userData?.name} ${userData?.surname}`,
          value: userData?.id,
        },
      ]);
    }
    if (!isOperator) {
      API.getUsersByRoles(
        ['OPERATOR', 'SUPERVISOR'],
        (result = []) => {
          const array = result
            .filter(({ deletedOn }) => deletedOn === null)
            ?.map(({ id, name, surname }) => ({
              label: `${name} ${surname}`,
              value: id,
            }));
          array.unshift({
            value: 0,
            label: intl.messages.NO_SELECTION,
          });

          setOperatorsList(array);
        },
        () => {}
      );
    } else {
      setOperatorsList([]);
    }
  }, [isOperator]);

  useEffect(() => {
    API.getCommercialCampaignsHistory(
      {
        pageNumber: 1,
        pageSize: 100,
        silent: true,
        filterExpression: mapFilters(
          [],
          [
            {
              keyName: 'isActive',
              operator: 'eq',
            },
          ],
          [],
          { isActive: true }
        ),
        sortExpression: {
          sortValue: 'startDate',
          sort: 'desc',
        },
      },
      (res) => {
        setCampaigns(res);
        if (!localStorage.getItem('kanbanCampaignId')) {
          localStorage.setItem('kanbanCampaignId', res[0]?.id || '');
        }
        setFilters((prev) => ({
          ...prev,
          campaignId:
            localStorage.getItem('kanbanCampaignId') || res[0]?.id || null,
        }));
      }
    );
  }, []);

  const handleChangeCampaign = (selectedCampaign) => {
    localStorage.setItem('kanbanCampaignId', selectedCampaign);
    setFilters((prev) => ({
      ...prev,
      campaignId: selectedCampaign,
    }));
  };

  const handleChangeOperator = (selectedOperator) => {
    setFilters((prev) => ({
      ...prev,
      operatorId: selectedOperator,
    }));
  };

  return (
    <Paper sx={{ width: '60%' }}>
      <FullSizeCenteredFlexBox gap="24px" padding="16px">
        <Typography variant="h6">{intl.messages.FILTERS}:</Typography>
        <SearchBox
          searchValues={filters}
          setSearchValues={setFilters}
          width="50%"
        />
        <Select
          width="50%"
          label="CAMPAIGN"
          name="campaign"
          options={campaigns?.map(({ id, description }) => ({
            label: description,
            value: id,
          }))}
          defaultValue={filters?.campaignId}
          onChange={handleChangeCampaign}
        />
        <Select
          width="50%"
          label="OPERATOR"
          name="operator"
          options={operatorsList}
          defaultValue={filters?.operatorId}
          onChange={handleChangeOperator}
        />
      </FullSizeCenteredFlexBox>
    </Paper>
  );
};

export default FiltersPaper;
